module.exports = __webpack_public_path__ + "media/mapv_1791549827195_17600.a53a2a4b.mp4";